import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/",
)({
  validateSearch: (search: Record<string, unknown>): { flowId: number } => {
    if (!search.flowId) {
      throw new Error("Missing flowId");
    }
    return {
      flowId: Number(search.flowId),
    };
  },
  // Do not cache this route's data after it's unloaded
  pendingMs: 0,
  gcTime: 0,
});
